import type { FulfillmentShipmentStatus } from '@pc/db';
import { SHIPMENT_STATUS_CLASSES, SHIPMENT_STATUS_LABELS } from '../types';

export function StatusChip({ status }: { status: FulfillmentShipmentStatus }) {
  return (
    <span
      className={`text-xs px-2 py-0.5 border whitespace-nowrap ${
        SHIPMENT_STATUS_CLASSES[status] ?? 'border-rule text-ink-2'
      }`}
    >
      {SHIPMENT_STATUS_LABELS[status] ?? status}
    </span>
  );
}
